import React, { useEffect } from 'react';
import { useMeritEngineNavigation } from '../../../hooks/useMeritEngineNavigation';
import ModDas from './ModDas';
import ModDemoPriceAnalysis from './ModDashboard/LoadPrice';
import DemoFileUploadTabComponent from './Resource/Upload/Upload';
import ModDemoChartTable from './Mod/ModTable/ModIndex';
import DemoSellBidTable from './Bid/BidIndex';
import ModDemoSimulationIndex from './ModSimulation/ModSimulationIndex';
import ModDemoArchive from './ModArchive/ModArchive';
import { ModDemoSelectedDate } from "../../../store/state/ModDemo/ModDate";
import { setModDemoSession } from "../../../store/state/ModDemo/ModSession";
import { setModDemoVersion } from "../../../store/state/ModDemo/ModVersion";
import { setModDemoSessionToken } from "../../../store/state/ModDemo/ModSessionToken";
import { useDispatch } from "react-redux";
import { getModDemoSession } from '../../../Rest_api/DemoRestApi';

const MeritEngineRouter: React.FC = () => {
  const { currentPage } = useMeritEngineNavigation();
  const dispatch = useDispatch();

  // useEffect to handle page refresh and navigation
  // useEffect(() => {
  //   // This component only renders when currentPage is 'dashboard' or null/undefined
  //   // The MeritEngineRouter handles rendering other pages
  //   console.log('ModDas rendered with currentPage:', currentPage);
  // }, [currentPage]);

  useEffect(() => {
    async function ModDemoSession() {
      const data = await getModDemoSession();

      if (data) {
        dispatch(ModDemoSelectedDate(data.date));
        dispatch(setModDemoSession(data.session));
        dispatch(setModDemoVersion(data.version));
        dispatch(setModDemoSessionToken(data.session_token));
      }
    }
    ModDemoSession();
  }, [dispatch]);

  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case 'load-price':
        return <ModDemoPriceAnalysis />;
      case 'resources':
        return <DemoFileUploadTabComponent />;
      case 'merit-order-dispatch':
        return <ModDemoChartTable />;
      case 'bid':
        return <DemoSellBidTable />;
      case 'simulation-generation':
        return <ModDemoSimulationIndex />;
      case 'archive':
        return <ModDemoArchive />;
      case 'dashboard':
      case null:
      case undefined:
      default:
        return <ModDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default MeritEngineRouter;
